import { z } from 'zod'
import { portfolioPositionResponseSchema } from './portfolio-position-response.schema'

// account cash (RUB) from T-Bank withdraw limits: money available to trade, money blocked
// (orders + margin guarantee), and their sum. total = available + blocked always holds.
export const portfolioCashSchema = z.object({
  available: z.number(),
  blocked: z.number(),
  total: z.number(),
})

export const portfolioResponseSchema = z.object({
  positions: z.array(portfolioPositionResponseSchema),
  totalAmountShares: z.number(),
  totalAmountBonds: z.number(),
  totalAmountEtf: z.number(),
  totalAmountCurrencies: z.number(),
  totalAmountPortfolio: z.number(),
  expectedYield: z.number(),
  dailyYield: z.number(),
  currency: z.string(),
  cash: portfolioCashSchema,
})

export type PortfolioCashDto = z.infer<typeof portfolioCashSchema>
export type PortfolioResponseDto = z.infer<typeof portfolioResponseSchema>
